<template>
  <div class="mod-info" style="padding-top: 60px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo"> <img :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" /> </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
      </div>
    </div>
    <div class="layout mt12">
      <ul class="mod-f-l mt15" @click="$parent.goNav('/userInfo')">
        <li class="no-next">
          <a href="javascript:void(0)"
            ><span class="fr f14px c6">{{ $store.state.userInfo.username }}</span
            ><span class="tit"><i class="usr-name"></i>用户名称</span></a
          >
        </li>

        <li class="no-next">
          <a id="goeditrName_btn"
            ><span class="fr f14px c6">{{ $store.state.userInfo.realname }}</span
            ><span class="tit"><i class="real-name"></i>真实姓名</span></a
          >
        </li>

        <li class="no-next">
          <a id="goinsertDOB_btn"
            ><span class="fr f14px c6">{{ $store.state.userInfo.birthday }}</span
            ><span class="tit"><i class="birth-icon"></i>出生日期</span></a
          >
        </li>
      </ul>

      <ul class="mod-f-l mt15" @click="$parent.goNav('/userInfo')">
        <li class="no-next">
          <a id="goinsertEmail_btn"
            ><span class="fr f14px c6" style="max-width: 60%; word-break: break-all">{{ $store.state.userInfo.email }}</span
            ><span class="tit"><i class="email-icon"></i>邮箱地址</span></a
          >
        </li>

        <li class="no-next">
          <a id="phoneNum_btn"
            ><span class="fr f14px c6">{{ $store.state.userInfo.mobile }}</span>

            <span class="tit"><i class="cell-icon"></i>手机号码 </span></a
          >
        </li>
      </ul>
      <ul class="mod-f-l mt15">
        <li class="no-next" @click="$parent.goNav('/password?type=1')">
          <a id="editLogPwd_btn"
            ><span class="tit"><i class="pswset-icon"></i><img src="/static/image/arrow-r.png" width="9" height="16" class="fr arrow-r" />修改登录密码</span></a
          >
        </li>
        <li class="no-next" @click="$parent.goNav('/password?type=2')">
          <a id="editLogPwd_btn"
            ><span class="tit"><i class="pswset-icon"></i><img src="/static/image/arrow-r.png" width="9" height="16" class="fr arrow-r" />修改支付密码</span></a
          >
        </li>
        <li class="no-next" @click="$parent.goNav('/wallet?type=1')">
          <a id="withBankCard_btn"
            ><span class="tit"><i class="wtdcard-icon"></i><img src="/static/image/arrow-r.png" width="9" height="16" class="fr arrow-r" />银行卡管理</span></a
          >
        </li>
        <li class="no-next" @click="$parent.goNav('/wallet?type=2')">
          <a id="usdtWithWallet_btn"
            ><span class="tit"><i class="wtdcard-icon"></i><img src="/static/image/arrow-r.png" width="9" height="16" class="fr arrow-r" />USDT钱包管理</span></a
          >
        </li>
        <li class="no-next" @click="$parent.goNav('/boutBallBet')">
          <a id="usdtWithWallet_btn"
            ><span class="tit"><i class="wtdcard-icon"></i><img src="/static/image/arrow-r.png" width="9" height="16" class="fr arrow-r" />帮助中心</span></a
          >
        </li>
      </ul>

      <div class="p15 mtb15">
        <a class="confirm-sub" @click="$parent.outLogin()" id="logout_btn">退出登录</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'setting',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
</style>



// WEBPACK FOOTER //
// src/components/setting.vue